import React, {Component} from 'react'
import {withSnackbar } from 'notistack'
import ConfirmationBox from '../../common/ConfirmationBox'

//material-ui components
import TextField from '@material-ui/core/TextField'
import Divider from '@material-ui/core/Divider'
import {TableWithActions} from './../../common/TableView'
import {FilterField, FilterDropDownWithLabel} from './../../common/FilterField'
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card'
import FilterListIcon from '@material-ui/icons/FilterList'
import MenuIcon from '@material-ui/icons/Menu';
import ProviderDetails from './ProviderDetails'
//styling
import {withStyles} from '@material-ui/core/styles'

//Context
import {getProviders,setPendingProvidersFilter} from '../../../context/users/Actions'
import {UserContext} from '../../../context/users/Context'

//firebase
import FirebaseApp from '../../../FirebaseSetup'

//orderRepository
import {fetchProviders,approveProvider} from '../../../repository/UsersRepository'

import LoadingScreen from '../../common/LoadingScreen'



const columns = [
        {title : 'Provider Id', field:'providerId'},
        {title : 'Provider Name', field:'firstName',render:rowData=><div>{rowData.firstName} {rowData.lastName}</div>},
        {title : 'Category', field:'services',render:rowData=>rowData.services.map((service) => {
            return (
                <div>{service}</div>
            )
        })},
        {title : 'City', field:'city'},
        {title : 'District', field:'district'},
]
const styles = {
    headingContainer : {
        display:'flex',
        flexDirection: 'row'
    },
    filterContainer: {

        paddingTop:'0',
    },
    divider:{
        marginTop:'10px',
        marginBottom:'10px'
    }
}



class NewProviders extends Component{

        constructor(props) {
            super(props)

            this.state = {
                    status:'NEW',
                    provider:'',
                    category:'',
                    city:'',
                    district:'',
                    pendingProviders:[],
                    selectedProvider:'',
                    providerDetails:false,
                    confirm:{
                        status:false,
                        message:''
                    },
                    loading:{
                        status:false,
                        message:''
                    },
            }
        }
    static contextType = UserContext

    setParams = () => {
        const {users} = this.context
        let params = {}
        params['status'] = this.state.status
        if(this.state.category!=''){
            params['services'] = this.state.category
        }
        if(this.state.provider!=''){
            params['firstName'] = this.state.provider
        }
        if(this.state.city!=''){
            params['city'] = this.state.city
        }
        if(this.state.district!=''){
            params['district'] = this.state.district
        }
        let arr = users.providers.filter(provider => {
            for (const [key, value] of Object.entries(params)) {
                if(key=="services"){
                    let check = 0
                    for(let x=0;x<provider.services.length;x++){
                        if(provider.services[x]==value){
                            check = 1
                        }
                    }
                    if(check==0){
                        return false
                    }else{
                        return true
                    }
                }
                else if(provider[key]!=value){
                    return false
                }
              }
              return true
        })
        this.setState({pendingProviders:arr})
    }

    saveFilter = () => {
        const {dispatch} = this.context

        let filter = {}
        filter['status'] = this.state.status
        filter['provider'] = this.state.provider
        filter['city'] = this.state.city
        filter['district'] = this.state.district
        filter['category'] = this.state.category
        dispatch(setPendingProvidersFilter(filter))
    }

    setFilter = () => {
        const {users} = this.context
        let filter = users.pendingProvidersFilter
        this.setState({provider:filter.provider})
        this.setState({city:filter.city})
        this.setState({district:filter.district})
        this.setState({status:filter.status})
        this.setState({category:filter.category})
    }

    getProviders = async () => {
        const {dispatch} = this.context
        this.setState({loading:{status:true,message:'Getting providers'}})
        try{
            await FirebaseApp.auth().currentUser.getIdToken(true).then((idToken) => {
                fetchProviders({},idToken).then((data) => {
                        dispatch(getProviders(data))
                        this.setParams()
                        this.setState({loading:{status:false,message:''}})
                }).catch((error)=>{
                    this.props.enqueueSnackbar("Import providers failed "+error,{variant:'error'})
                   this.setState({loading:{status:false,message:''}})
                })
              })
        }catch(error){
            this.props.enqueueSnackbar("Import providers failed "+error,{variant:'error'})
            this.setState({loading:{status:false,message:''}})
        }
    }

    approveProvider = async () => {
        let providerId = this.state.selectedProvider
        this.setState({loading:{status:true,message:'Approving selected provider'}})

        try{
            await FirebaseApp.auth().currentUser.getIdToken(true).then((idToken) => {
                approveProvider(providerId,idToken).then((data) => {
                        this.getProviders()
                        this.setParams()
                        this.setState({loading:{status:false,message:''}})
                        this.props.enqueueSnackbar("Provider was approved successfully ",{variant:'success'})
                }).catch((error)=>{
                    this.props.enqueueSnackbar("Approve provider failed "+error,{variant:'error'})
                   this.setState({loading:{status:false,message:''}})
                })
              })
        }catch(error){
            this.props.enqueueSnackbar("Approve provider failed "+error,{variant:'error'})
            this.setState({loading:{status:false,message:''}})
        }

    }

    componentDidMount = () => {
        const {users} = this.context
         if(users.providers.length==0){
             this.getProviders()
         }
         this.setFilter()
         this.setParams()
    }

    componentWillUnmount = () => {
        this.saveFilter()
    }
    render(){
        const {classes} = this.props
        const {users} = this.context
        return(
            <div>
                <div  className ="d-flex flex-row">
                    <Card>
                    <div className="w-100 d-flex flex-row">
                            <div style={{width:'180px',marginTop:'14px'}}>
                            <FilterField 
                                    disabled={false}
                                    label = "Name"
                                    placeholder = "Name"
                                    value = {this.state.provider}
                                    onChange = { e => {this.setState( {provider:e.target.value})}}
                                    />
                            </div>
                            <div style={{width:'180px',marginTop:'14px'}}>
                            <FilterField 
                                    disabled={false}
                                    label = "City"
                                    placeholder = "City"
                                    value = {this.state.city}
                                    onChange = { e => {this.setState( {city :e.target.value})}}
                                    />
                               
                            </div>
                            <div style={{width:'180px',marginTop:'14px'}}>
                            <FilterField 
                                    disabled={false}
                                    label = "District"
                                    placeholder = "District"
                                    value = {this.state.district}
                                    onChange = { e => {this.setState( {district : e.target.value})}}
                                    />
                            </div>
                            <div style={{width:'180px',marginTop:'16px',marginLeft:'10px',marginRight:'10px'}}>
                            <FilterDropDownWithLabel
                                label="Category"
                                optionLabelId = 'categoryName'
                                optionValueId = 'categoryId'
                                value = {this.state.category}
                                options = {this.props.categories}
                                onChange={(e)=>this.setState({category : e.target.value})}
                            />
                        </div> 

                        <div style={{alignSelf:'center',margin:'10px',marginRight:'20px'}}>
                            <Button
                                variant="contained"
                                startIcon={<FilterListIcon/>}
                                size = "small"
                                onClick = {(e) => {
                                    this.setParams()
                                    this.saveFilter()
                                }}
                            >Filter
                            </Button>
                        </div> 
                        <div style={{alignSelf:'center',margin:'10px',marginRight:'20px'}}>
                            <Button
                                variant="contained"
                                startIcon={<FilterListIcon/>}
                                size = "small"
                                onClick = {(e) => {
                                    this.getProviders()
                                }}
                            >Refresh
                            </Button>
                        </div>                 
                    </div>
                    </Card>
                </div>
                <Divider style={styles.divider}/>
                <div>

                <TableWithActions
                    columns = {columns}
                    data = {this.state.pendingProviders}
                    actions = {[
                        {
                            icon: MenuIcon,
                            tooltip: 'Approve',
                            onClick:(e,rowData)=> {
                                this.setState({selectedProvider:rowData})
                                this.setState({providerDetails:true})
                                
                            }
                        },
                    ]}
                />


            </div>
            {this.state.confirm.status?
                    <   ConfirmationBox
                        open={this.state.confirm.status}
                        message = {this.state.confirm.message}
                        handleClose = {(e)=>{this.setState({confirm:{...this.state.confirm,status:false},selectedProvider:''})}}
                        handleCloseConfirmed = {
                            (e)=>{
                                this.setState({providerDetails:true})
                               
                            }
                        }
                    />
                    :null    
                    }
            {this.state.loading.status?
                    <LoadingScreen
                        width='100%'
                        height='100%'
                        translateY ='300px'
                        message = {this.state.loading.message}
                    />
                    :null    
                    }
                {this.state.providerDetails==true?
                <ProviderDetails
                    open={this.state.providerDetails}
                    provider = {this.state.selectedProvider}
                    categories = {this.props.categories}
                    pendingProvider = {true}
                    handleClose={(e)=>{
                        this.setState({providerDetails:false})
                    }}
                    handleCloseWithRefresh={(e)=>{
                        this.setState({providerDetails:false})
                        this.getProviders()
                }}
                />    
                :null
            }
            </div>
        )
    }
}

export default withSnackbar((NewProviders))